import React from 'react'


export default class FavoritesBox extends React.Component {
  state = {
    editing: null,
    selected: 0,
  }

  stopClick(e) {
    e.stopPropagation()
  }

  toggleEditing( rowId, rowCategoryId ) {
    this.setState({
      editing: rowId,
      selected: rowCategoryId,
    })
  }

  handleEditField(event) {
    if ( event.keyCode === 13 ) {
      let target = event.target,
        update = {}

      update.id = this.state.editing

      let value = target.value

      if (target.name === 'tags') {
        if (target.value === '') {
          value = []
        } else {
          value = target.value.split(',')
        }
      } else {
        value = target.value
      }

      update[target.name] = value

      this.handleFavoriteUpdate(update)
    }
  }

  handleChangeField(event) {
    this.setState({selected: event.target.value})
  }

  handleEditItem() {
    let itemId = this.state.editing

    this.handleFavoriteUpdate({
      id: itemId,
      category: this.refs[ `category_${ itemId }` ].value,
      query: this.refs[ `query_${ itemId }` ].value,
      tags: this.refs[ `tags_${ itemId }` ].value.split(','),
    })
  }

  handleFavoriteUpdate(data) {
    this.props.editFavorite(data, (result) => {
      if (result) {
        this.setState({
          editing: null,
          selected: 0,
        })
      }
    })
  }

  renderTable( list ) {
    const rows = list.map((row) => {
      if ( this.state.editing === row.id ) {
        return <tr key={ row.id } >
          <td>
            <select name="category" ref={ `category_${ row.id }` } className="form-control" value={this.state.selected} onChange={this.handleChangeField.bind(this)}>
              <option value="All">All</option>
              <option value="Audio">Audio</option>
              <option value="eBook">eBook</option>
              <option value="Emulation">Emulation</option>
              <option value="Jeu vidéo">Jeu vidéo</option>
              <option value="GPS">GPS</option>
              <option value="Application">Application</option>
              <option value="Film/Vidéo">Film/Vidéo</option>
              <option value="Série">Série</option>
              <option value="xXx">xXx</option>
            </select>
          </td>
          <td>
            <input
              onKeyDown={ this.handleEditField.bind(this) }
              type="text"
              className="form-control"
              ref={ `query_${ row.id }` }
              name="query"
              defaultValue={ row.query }
            />
          </td>
          <td>
            <input
              onKeyDown={ this.handleEditField.bind(this) }
              type="text"
              className="form-control"
              ref={ `tags_${ row.id }` }
              name="tags"
              defaultValue={ row.tags.toString() }
            />
          </td>
          <td>{row.toggle}</td>
          <td><button type='submit' className='form-control button btn-success' onClick={ this.handleEditItem.bind(this) }>Modifier</button></td>
        </tr>
      } else {
        return <tr key={ row.id } onClick={ this.toggleEditing.bind(this, row.id, row.categoryId) }>
          <td>{row.category}</td>
          <td>{row.query}</td>
          <td>{row.tags.toString()}</td>
          <td onClick={this.stopClick.bind(this)}>{row.toggle}</td>
          <td onClick={this.stopClick.bind(this)}>{row.delete}</td>
        </tr>
      }
    })
    return rows
  }

  render() {
    let favoritesList = this.props.favoritesList
    return (
      <table className="table table-striped">
        <thead>
        </thead>
        <tbody>
          { this.renderTable(favoritesList) }
        </tbody>
      </table>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/favorites/FavoritesBox.js